import { Radio, SxProps, Theme } from '@mui/material'

import { switcherLabelWithImageStyle } from 'common/styles'
import FormControlLabel from 'components/FormControlLabel'
import ImageCard from 'components/ImageCard'

import { RadioImageOption } from '../interface'

interface RadioItemWithImageProps {
  option: RadioImageOption
}

const radioStyles: SxProps<Theme> = {
  display: 'none',
}

export default function RadioItemWithImage({ option }: RadioItemWithImageProps): JSX.Element {
  const { image, imageAltText, heading, subheading, value } = option

  return (
    <FormControlLabel
      sx={switcherLabelWithImageStyle}
      key={value}
      value={value}
      label={
        <ImageCard
          heading={heading}
          image={image}
          subheading={subheading}
          imageAltText={imageAltText}
        />
      }
      control={<Radio sx={radioStyles} />}
    />
  )
}
